$(document).on('turbo:load', () => {
  if ($('#purchases-summary').length !== 0) {
    $('#return_to_widget_event').on('click', () => {
      window.top.location.reload()
    })
  }
})
